import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { getTicket } from "@/api/ayv3/base";
import { MessageBox } from "element-ui";
import { getCookieByKey, removeTokenByKey, setTokenByKey } from "@/libs/util";

Vue.use(Router);

const router = new Router({
    routes: [{
        path: "/",
        name: "home",
        component: () => import("./views/Home.vue"),
        meta: {
            title: "首页"
        },
        children: [{
                path: "index",
                name: "index",
                meta: { title: "首页" },
                component: () => import("./views/index.vue")
            },
            {
                path: "about",
                name: "about",
                meta: { title: "关于我们" },
                component: () => import("./views/about.vue")
            },
            {
                path: "question",
                name: "question",
                meta: { title: "旅游问答" },
                component: () => import("./views/question.vue")
            },
            {
                path: "ques_view",
                name: "ques_view",
                meta: { title: "问答详情", notCache: true },
                component: () => import("./views/ques_view.vue")
            },
            {
                path: "contant",
                name: "contant",
                meta: { title: "门店网点" },
                component: () => import("./views/contant.vue")
            },
            {
                path: "mdmap",
                name: "mdmap",
                meta: { title: "门店地图分布" },
                component: () => import("./views/mdmap.vue")
            }
        ]
    }]
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title + " 中国国旅宁波";
    if (to.name === "home") {
        next({ path: "index" });
    } else {
        let infojson = getCookieByKey("wcits");
        if (infojson !== false) {
            infojson = JSON.parse(infojson);
            store.commit("setTicket", infojson.ticket);
            store.commit("setCookie");
            next();
        } else {
            if (store.state.app.ticket === "") {
                var params = {
                    client_id: store.state.app.client_id
                };
                getTicket(params).then(res => {
                    if (res.data.code === 0) {
                        store.commit("setTicket", res.data.data);
                        store.commit("setCookie");
                        next();
                    } else {
                        MessageBox(res.data.message, "提示");
                    }
                });
            } else {
                next();
            }
        }
    }
});
router.afterEach(to => {});
export default router;